export default "__VITE_ASSET__c7ef0c1c__"